/*
 * Copyright (c) 2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import { DocumentIcon, XMarkIcon } from '@heroicons/react/24/outline'

interface EmailTemplateAttachmentItemProps {
    file: File | { name: string; type?: string }
    index: number
    onRemove?: (index: number) => void
}

const EmailTemplateAttachmentItem: React.FC<EmailTemplateAttachmentItemProps> = ({ file, index, onRemove }) => {
    return (
        <div className="EmailTemplateAttachmentItem flex items-center gap-2 px-3 py-1.5 bg-blue-50 dark:bg-blue-900/20 text-blue-700 dark:text-blue-300 rounded-full border border-blue-100 dark:border-blue-800 text-xs transition-all">
            <DocumentIcon className="w-3.5 h-3.5" />
            <span className="max-w-[150px] truncate">{file.name}</span>
            {onRemove && (
                <button
                    type="button"
                    onClick={() => onRemove(index)}
                    className="hover:text-red-500 transition-colors"
                >
                    <XMarkIcon className="w-3.5 h-3.5" />
                </button>
            )}
        </div>
    )
}

export default EmailTemplateAttachmentItem
